<template>
    <button
        v-tippy="t('editorAddColumnAfter')"
        :class="[buttonState(editor.can().addColumnAfter()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().addColumnAfter()"
        @click="editor.chain().focus().addColumnAfter().run()"
    >
        <MdiTableColumnPlusAfter class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableColumnPlusAfter from 'materialdesignicons-vue3/icons/MdiTableColumnPlusAfter.js';

    defineExpose({
        name: 'AddTableColumnAfterButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
